import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { SortingState } from '@tanstack/react-table';

import {
  getOfferRecommendations,
  getOfferRecommendationsList,
} from '@/services/offerRecommendations';

export const offerRecommendations = createQueryKeys('offerRecommendations', {
  list: ({
    limit,
    offset,
  }: Parameters<typeof getOfferRecommendationsList>[0] = {}) => ({
    queryKey: [limit, offset],
    queryFn: () => getOfferRecommendationsList({ limit, offset }),
  }),
  recommendations: (id: string, order?: SortingState) => ({
    queryKey: [id, order],
    queryFn: () => getOfferRecommendations(id, order),
  }),
});
